export default "__VITE_ASSET__DLynWWyF__"